import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3dc954e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "coin-history-page-section" }
const _hoisted_2 = { class: "dialog-right" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" ประวัติการใช้คอยน์ ")
const _hoisted_6 = {
  key: 0,
  class: "body"
}
const _hoisted_7 = { class: "coin-history-header" }
const _hoisted_8 = { class: "coin-history-body" }
const _hoisted_9 = {
  class: "coin-history-list",
  id: "list-container"
}
const _hoisted_10 = { class: "top" }
const _hoisted_11 = { class: "filter" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 0,
  class: "dummy-item"
}
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "history-title" }
const _hoisted_17 = { class: "history-title-cell" }
const _hoisted_18 = {
  key: 0,
  class: "history-empty"
}
const _hoisted_19 = { class: "history-content" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "history-detail" }
const _hoisted_22 = { class: "history-type" }
const _hoisted_23 = { class: "history-reason" }
const _hoisted_24 = { class: "history-date" }
const _hoisted_25 = {
  key: 3,
  class: "dummy-bottom"
}
const _hoisted_26 = {
  key: 1,
  class: "empty-page"
}
const _hoisted_27 = { class: "empty-container" }
const _hoisted_28 = ["src"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-content" }, [
  /*#__PURE__*/_createElementVNode("p", null, "ไม่มีประวัติการใช้คอยน์"),
  /*#__PURE__*/_createElementVNode("p", null, "เพิ่มคอยน์ของคุณง่ายๆ ด้วยการช้อป")
], -1))

export function render(_ctx, _cache) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_CoinHistoryHeader = _resolveComponent("CoinHistoryHeader")
  const _component_LoadingCoinHistory = _resolveComponent("LoadingCoinHistory")
  const _component_Error = _resolveComponent("Error")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['coin-history-page', _ctx.isModalClose ? 'hide' : 'show']),
      style: _normalizeStyle({ zIndex: !_ctx.isModalClose ? 10000 : 10060 })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "arrow",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.closeModal()))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-left" }),
              _hoisted_5
            ])
          ]),
          (!_ctx.isPointsError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_CoinHistoryHeader, { isLoadingPoints: _ctx.isLoadingPoints }, null, 8, ["isLoadingPoints"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", {
                          class: "menu",
                          onClick: _cache[1] || (_cache[1] = $event => (_ctx.onSelected('all')))
                        }, [
                          _createElementVNode("p", {
                            class: _normalizeClass({ 'active': _ctx.active === 'all' })
                          }, "ทั้งหมด", 2)
                        ]),
                        _createElementVNode("div", {
                          class: "menu",
                          onClick: _cache[2] || (_cache[2] = $event => (_ctx.onSelected('earn')))
                        }, [
                          _createElementVNode("p", {
                            class: _normalizeClass({ 'active': _ctx.active === 'earn' })
                          }, "ได้รับ", 2)
                        ]),
                        _createElementVNode("div", {
                          class: "menu",
                          onClick: _cache[3] || (_cache[3] = $event => (_ctx.onSelected('burn')))
                        }, [
                          _createElementVNode("p", {
                            class: _normalizeClass({ 'active': _ctx.active === 'burn' })
                          }, "ใช้ไป", 2)
                        ])
                      ]),
                      (_ctx.coinHistoryList.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["month", { 'active': _ctx.isHighlightMonthActive }])
                          }, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("span", {
                                class: _normalizeClass({ 'active': _ctx.activeMonthState === 'primary' })
                              }, _toDisplayString(_ctx.activeMonthPrimary), 3),
                              _createElementVNode("span", {
                                class: _normalizeClass({ 'active': _ctx.activeMonthState === 'secondary' })
                              }, _toDisplayString(_ctx.activeMonthSecondary), 3)
                            ]),
                            _createElementVNode("img", {
                              onClick: _cache[4] || (_cache[4] = $event => (_ctx.onShowModalCalendar())),
                              class: "calendar-icon",
                              src: require('../../assets/img/calendar.png')
                            }, null, 8, _hoisted_13)
                          ], 2))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", {
                      class: "detail",
                      id: "coin-history-list",
                      onScroll: _cache[5] || (_cache[5] = (...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
                    }, [
                      (!_ctx.isLoading && _ctx.coinHistoryList.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                        : _createCommentVNode("", true),
                      (_ctx.isLoading)
                        ? (_openBlock(), _createBlock(_component_LoadingCoinHistory, { key: 1 }))
                        : _createCommentVNode("", true),
                      (_ctx.coinHistoryList.length && !_ctx.error)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.coinHistoryList, (coinHistory, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              id: `month_${index}`
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coinHistory, (historys, month) => {
                                return (_openBlock(), _createElementBlock("div", null, [
                                  _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, _toDisplayString(month), 1)
                                  ]),
                                  (historys.length === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, " ไม่มีข้อมูล "))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(historys, (history, index) => {
                                        return (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                          (_ctx.getActivity(history))
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                class: "history-icon",
                                                src: require('../../assets/img/' + _ctx.getActivity(history))
                                              }, null, 8, _hoisted_20))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["history-container", { 'line': historys.length !== index+1 }])
                                          }, [
                                            _createElementVNode("div", _hoisted_21, [
                                              _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.getTypeOfCoinHistory(history)), 1),
                                              _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.getNote( history )), 1),
                                              _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.getDate(history.timeOfOccurrence)), 1)
                                            ]),
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["history-coin", { 'gray': history.modification < 0}])
                                            }, _toDisplayString(`${history.modification > 0 ? '+' :
                          ''}${_ctx.getLabelPoints(history.modification)}`), 3)
                                          ], 2)
                                        ]))
                                      }), 256))
                                ]))
                              }), 256))
                            ], 8, _hoisted_15))
                          }), 256))
                        : _createCommentVNode("", true),
                      (!_ctx.isLoading && _ctx.coinHistoryList.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25))
                        : _createCommentVNode("", true)
                    ], 32),
                    (!_ctx.isLoading && _ctx.error)
                      ? (_openBlock(), _createBlock(_component_Error, {
                          key: 0,
                          errorCode: _ctx.error,
                          refCode: _ctx.refCodeError,
                          onRefresh: _ctx.getCoinHistory
                        }, null, 8, ["errorCode", "refCode", "onRefresh"]))
                      : _createCommentVNode("", true),
                    (!_ctx.error && !_ctx.isLoading && _ctx.coinHistoryList.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("img", {
                              class: "icon",
                              src: require('../../assets/img/no-transaction.png')
                            }, null, 8, _hoisted_28),
                            _hoisted_29,
                            _createElementVNode("button", {
                              class: "btn",
                              onClick: _cache[6] || (_cache[6] = $event => (_ctx.handleRedirectApp()))
                            }, "ช้อปเลย !")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isLoadingPoints && !_ctx.isLoading  && _ctx.isPointsError)
            ? (_openBlock(), _createBlock(_component_Error, {
                key: 1,
                errorCode: _ctx.error,
                refCode: _ctx.refCodeError,
                onRefresh: _ctx.onRefresh
              }, null, 8, ["errorCode", "refCode", "onRefresh"]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 6)
  ]))
}